import { booleanAttribute, ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';
import { SelectListOption } from '@bmw-ds/components';

import { SuggestedAddress } from '../../../clients/tolerant-post/model/view.model';
import { AddressField } from '../../../customer/model/address-field.model';
import { CustomerAddress } from '../../../customer/model/customer-information.model';
import { SuggestionOfAddressField } from '../../../customer/services/address.view-service';
import { RegionalAddressFieldComponent } from './regional-address-field.component';

@Component({
  selector: 'cdf-regional-address-row',
  host: { class: 'd-flex gap-2x flex-wrap' },
  imports: [RegionalAddressFieldComponent],
  template: `
    <!-- The computed tracker is needed to suppress NG0956 -->
    @for (addressField of addressRow(); track addressField + '') {
      <cdf-regional-address-field
        [(address)]="address"
        [addressField]="addressField"
        [availableCountries]="availableCountries()"
        [availableProvinces]="availableProvinces()"
        [disabled]="disabled()"
        [disableIfNoCountry]="disableIfNoCountry()"
        [displayError]="invalidAddressFields().includes(addressField)"
        [isClearable]="isClearable()"
        [suggestions]="suggestions()"
        (selectedSuggestionForAddressField)="selectedSuggestionForAddressField.emit($event)"
      />
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegionalAddressRowComponent {
  readonly addressRow = input.required<AddressField[]>();

  readonly address = model.required<CustomerAddress | undefined>();

  // Disable all other input fields, if not country is set.
  readonly disableIfNoCountry = input(false, { transform: booleanAttribute });
  readonly disabled = input(false);

  readonly invalidAddressFields = input<AddressField[]>([]);

  readonly availableCountries = input<SelectListOption[]>();
  readonly availableProvinces = input<SelectListOption[]>([]);
  readonly isClearable = input(false, { transform: booleanAttribute });

  readonly suggestions = input<SuggestedAddress[] | undefined>(undefined);

  readonly selectedSuggestionForAddressField = output<SuggestionOfAddressField>();
}
